import React, { Component } from 'react';
import Slider from 'react-slick';
import { inject, observer } from 'mobx-react';

@inject('appStore')
@observer
class HomeSlider extends Component {

  container = React.createRef();

  state = {
    scale: 1,
  }

  componentDidMount() {
    this.props.appStore.loadSlider();
    const height = this.container.current.offsetHeight;

    const scale = +(height / 1080).toFixed(2);
    this.setState({ scale: scale < 1 ? scale : 1 });
  }

  render() {
    const settings = {
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };

    const { slides } = this.props.appStore;
    // const slides = typeof this.props.appStore.slides.length > 0 ? 1 : 0;
    return (
      <div className="home-slider" style={{ fontSize: this.state.scale * 100 }} ref={this.container}>
        {slides ?
          <Slider {...settings}>
            {
              slides.map(image => {
                  const img = typeof image.images_url === 'string' ? JSON.parse(image.images_url).webp
                    : image.images_url ? image.images_url.webp : image.img;
                  return <div key={image.id} className="home-slider__slide-wrap">
                    <div className="home-slider__slide-image"
                         style={{ backgroundImage: `url(${img})` }}/>
                    <TextOverlay data={image.locales} settings={image.extended_settings}/>
                  </div>

                }
              )
            }
          </Slider> : ''
        }
      </div>
    );
  }
}

const TextOverlay = ({ data, settings }) => {
  if (!data) return null;
  return (
    <div
      className="home-slider-slide-over"
      style={{
        '--color': settings.text_color,
      }}
    >
      <div className="home-slider-slide-over-hc">
        {data.highlighted && (
          <span className="home-slider-slide-over-hc-t">{data.highlighted}</span>
        )}
      </div>
      <span className="home-slider-slide-over-l2">{data.heading_h2}</span>
      <span className="home-slider-slide-over-l1">{data.heading_h1}</span>
      <span className="home-slider-slide-over-l2">{data.heading_h3}</span>
    </div>
  );
};


export default HomeSlider;


// WEBPACK FOOTER //
// ./src/components/homeSlider/index.js